import { render } from "./Apartments.vue?vue&type=template&id=5026f9f2&scoped=true"
import script from "./Apartments.vue?vue&type=script&lang=js"
export * from "./Apartments.vue?vue&type=script&lang=js"

import "./Apartments.vue?vue&type=style&index=0&id=5026f9f2&scoped=true&lang=scss"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5026f9f2"]])

export default __exports__